<template>
  <router-view />
</template>

<script>
export default {
  name: 'PatternInsightsIndex'
}
</script>
